import styled from 'styled-components';

export const ProcessesWrapper = styled.div`
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    margin-top: 24px;
  }
`;
